// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"f3f83d7b","container":"d61e9848","title":"dd4a51ac","inner":"d379b73b"};